import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardActions } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VSpacer } from 'vuetify/lib/components/VGrid';

var render = function render(){var _vm=this,_c=_vm._self._c;return _c(VDialog,{attrs:{"no-click-animation":"","persistent":"","width":"500","transition":false},model:{value:(_vm.showDialog),callback:function ($$v) {_vm.showDialog=$$v},expression:"showDialog"}},[_c(VCard,[_c(VCardTitle,[_vm._v(_vm._s(_vm.$t('globals.newVersionTitle')))]),_c(VCardText,[_vm._v(_vm._s(_vm.$t('globals.newVersionText')))]),_c(VDivider),_c(VCardActions,[_c(VSpacer),_c(VBtn,{staticClass:"primary",on:{"click":_vm.reload}},[_vm._v(" "+_vm._s(_vm.$t('globals.reloadButton'))+" ")])],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }